import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createJournal,
  CreateJournalRequest,
  CreateJournalResponse,
  journalsQueries,
} from "@entities/journal";

export function useCreateJournal({ buildingObjectId }: CreateJournalRequest) {
  const queryClient = useQueryClient();

  return useMutation<CreateJournalResponse, Error, CreateJournalRequest>({
    mutationFn: createJournal,

    onSuccess: () => {
      queryClient.invalidateQueries(
        journalsQueries.getDraftJournals({
          buildingObjectId,
        }),
      );
    },

    onError: () => {},
  });
}
